import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AB_API_QRCODE_STATUS } from '../../../app/shared/constants';
import { ApiClientService } from '../../../app/shared/services/api-client.service';

export interface StatusResponse {
  callIsSuccess: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class StatusService extends ApiClientService {
  constructor(http: HttpClient) {
    super(http, AB_API_QRCODE_STATUS);
  }

  getStatus(loginRequestId: string): Observable<StatusResponse> {
    return this.post({
      loginRequestId
    });
  }
}
